module.exports = __webpack_public_path__ + "img/white-sapote-350x184.b5910162.jpg";